// extracted by mini-css-extract-plugin
export default {"font-renta":"LeftPanel_font-renta__cVMFw","leftPanel":"LeftPanel_leftPanel__iEQsa","minimize":"LeftPanel_minimize__s1o15","minimized":"LeftPanel_minimized__ByrOJ"};